import OfflineSvg from "./OfflineSvg";
import { RetryButton } from "./retryBtn";

export default function OfflinePage() {
  return (
    <main className="offline-container">
      <div className="content">
        <div className="imageWrapper">
          <OfflineSvg />
        </div>
        <h2 className="title">
          <span className="oops">Oops!</span> Connection Issue
        </h2>
        <p className="message">
          It seems like you&apos;re offline. Please check your internet
          connection and try again.
        </p>
        <RetryButton />
      </div>
    </main>
  );
}
